import { useRef, useState, useEffect } from "react";
import { getBrands, getContactTypes } from "../../api/axios"
import Header from "../../components/Header"
import ContactsListsTable from "../list/ContactsListsTable"
import useAuth from "../../hooks/useAuth";

const ContactsLists = () => {

  const [isLoading, setIsLoading] = useState(true);
  const idBrandRef = useRef();
  const [idBrand, setIdBrand] = useState('0');
  const [idBrands, setIdBrands] = useState([]);

  const idContactTypeRef = useRef();
  const [idContactType, setIdContactType] = useState('0');
  const [idContactTypes, setIdContactTypes] = useState([]);

  const [name, setName] = useState('');

  const { auth } = useAuth();
  
  useEffect(() => {

    const fetchData = async () => {
      
      setIsLoading(true);
      
      try {
        
        let data = await getBrands({ auth });
        setIdBrands(data.results);

        data = await getContactTypes({ auth });
        setIdContactTypes(data.results);

      } catch (error) {

        setIdBrands(null);
        setIdContactTypes(null);

      }

      setIsLoading(false);

    };

    fetchData();
    
  }, [auth]);


  
  const handleSubmit = (event) => {

    event.preventDefault();

    setIdBrand(event.target.idBrand.value);
    setIdContactType(event.target.idContactType.value);
    setName(event.target.name.value);
    
  }

  return (

    <>

      <Header />
              
        <div className="content">

          <h2 className="page_title">Listas de destinatarios</h2>

          <div className="table_div">


            <div className="filters_div">

              <form action="" onSubmit={handleSubmit}>

                <ul>

                  <li>
                    <label htmlFor="idBrand">
                      <span>Marca</span>
                      <select 
                        ref={idBrandRef}
                        id="idBrand" 
                        name="idBrand" 
                      >
                        <option value="0"></option>
                        
                      {!isLoading && idBrands && idBrands?.map((option, index) => (
                        <option key={index} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                      
                      </select>
                    </label>
                  </li>
                  <li>
                    <label htmlFor="idContactType">
                      <span>Tipo de destinatario</span>
                      <select 
                        ref={idContactTypeRef}
                        id="idContactType" 
                        name="idContactType" 
                      >
                        <option value="0"></option>
                        
                      {!isLoading && idContactTypes && idContactTypes?.map((option, index) => (
                        <option key={index} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                      
                      </select>
                    </label>
                  </li>
                  
                  <li>
                    <label htmlFor="name">
                      <span>Nombre</span>
                      <input 
                        name="name" 
                        type="text"                         
                      />
                    </label> 
                  </li>
                  <li>
                    <button className="button-outline" type="submit">Buscar</button>
                  </li>
                </ul>

              </form>

            </div>

            <ContactsListsTable params={ { idBrand, idContactType, name } } />

          </div>

        </div>

    </>
    
    )
}

export default ContactsLists
